import {
  ForecastApiData,
  Parameters,
  ForecastTableData,
  ForecastTableRow,
  FeedForecastResponse,
} from '@app/models/feed_forecast/FeedForecastResponse';
import { post, get } from './http.api';
import { ForecastRequest } from '@app/models/feed_forecast/FeedForecastRequest';

export const getForecastData = async (parameters: Parameters): Promise<ForecastTableData> => {
  try {
    const { data, status } = await get<any>(
      'feed_forecasts',
      {
        params: parameters,
      },
      true,
    );
    console.log(`Status: ${status}`, `Data:`, data);
    const feedForecasts: ForecastTableRow[] = data.pr_feed_forecasts.data.map((forecastData: any) => ({
      id: forecastData.id,
      year: forecastData.year,
      status: forecastData.status,
    }));

    return {
      data: feedForecasts,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching Product Registrations:', error);
    throw error;
  }
};

export const getAllForecasts = async (): Promise<FeedForecastResponse> => {
  try {
    const { data, status } = await get<FeedForecastResponse>(`feed_forecasts`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getForecastById = async (id: number): Promise<FeedForecastResponse> => {
  try {
    const { data, status } = await get<FeedForecastResponse>(`feed_forecasts/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeForecast = async (forecastData: ForecastRequest) => {
  try {
    const response = await post<any>('feed_forecasts/create', forecastData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createForecast = async (): Promise<ForecastApiData> => {
  try {
    const { data, status } = await get<ForecastApiData>(`feed_forecasts/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showForecast = async (id: number) => {
  try {
    const { data, status } = await get<ForecastApiData>(`feed_forecasts/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editForecast = async (id: number) => {
  try {
    const { data, status } = await get<ForecastApiData>(`feed_forecasts/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateForecast = async (id: number, UpdateForecast: ForecastRequest) => {
  try {
    const { data, status } = await post<ForecastRequest>(`feed_forecasts/${id}/edit`, UpdateForecast, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
